if(!customElements.get('article-banner-blog-post')) {
    customElements.define('article-banner-blog-post',
        class articleBannerBlogPost extends HTMLElement {
            constructor() {
              super();
              this.slider = null;
              this.sectionID = this.getAttribute('data-section-id');
              this.innitSlider();
            }
            innitSlider() {
              console.log('build slider')
              let slider = this.querySelector('.article-slider');
              let sectionID = this.sectionID;
  
              console.log('sectionId333', sectionID)
              this.slider = new Swiper(`.article-slider-${sectionID}`, {
                slidesPerView: 'auto',
                navigation: {
                  nextEl: `.swiper-button-next-${sectionID}`,
                  prevEl: `.swiper-button-prev-${sectionID}`,
                },
              });
            }
        }
    )
  }